import React from 'react';
import flowRight from 'lodash.flowright';
import { injectIntl } from 'react-intl';

import SecondaryButton from '../../../partials/customButtons/SecondaryButton';
import PrimaryButton from '../../../partials/customButtons/PrimaryButton';

export function ActionsButtons({ onCloseClick, handleSubmit, dirty, intl }) {
  return (
    <>
      <PrimaryButton onClick={handleSubmit} disabled={!dirty}>
        {intl.formatMessage({
          id: 'BUTTON.SUBMIT'
        })}
      </PrimaryButton>
      <SecondaryButton onClick={onCloseClick}>
        {intl.formatMessage({
          id: 'BUTTON.CANCEL'
        })}
      </SecondaryButton>
    </>
  );
}

export default flowRight(injectIntl)(ActionsButtons);
